import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

import APP_ROUTES from "../../../routers/routeConstants";
import { usePaymentAccounts } from "../../../api/queries/payment/paymentQueries";

import PaymentHeader from "../components/PaymentHeader";
import LearnMorePopUp from "../components/LearnMorePopUp";

import DashboardView from "./DashboardView/DashboardView";
import SelectCountryPopUp from "./NoPaymentAccountView/SelectCountryPopUp";
import NoPaymentAccountsView from "./NoPaymentAccountView/NoPaymentAccountsView";

import ReceivingDetailsPopUp from "../components/ReceivingDetailsPopUp/ReceivingDetailsPopUp";

const PaymentOverview = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [isLearnMorePopUpOpen, setIsLearnMorePopUpOpen] = useState(false);
  const [isSelectCountryPopUpOpen, setIsSelectCountryPopUpOpen] = useState(false);
  const [isReceivingDetailsPopUpOpen, setIsReceivingDetailsPopUpOpen] = useState(false);

  const openLearnMorePopUp = () => setIsLearnMorePopUpOpen(true);
  const closeLearnMorePopUp = () => setIsLearnMorePopUpOpen(false);

  const openSelectCountryPopUp = () => setIsSelectCountryPopUpOpen(true);
  const closeSelectCountryPopUp = () => setIsSelectCountryPopUpOpen(false);

  const handleSetupPaymentAccount = () => navigate(APP_ROUTES.CREATE_PAYMENT_ACCOUNT);

  const handleAddReceivingDetails = () => setIsReceivingDetailsPopUpOpen(true);

  const closeReceivingDetailsPopUp = () => setIsReceivingDetailsPopUpOpen(false);

  const { userPaymentAccount, isUserPaymentAccountLoading, isUserPaymentAccountHasError } = usePaymentAccounts();

  const disableCanCreatePaymentLink =
    isUserPaymentAccountLoading || !userPaymentAccount || isUserPaymentAccountHasError;
  return (
    <Box
      sx={{
        padding: "12px",
        width: "100%",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        rowGap: "24px",
      }}
    >
      <PaymentHeader
        openLearnMorePopUp={openLearnMorePopUp}
        handleSetupPaymentAccount={openSelectCountryPopUp}
        disableCanCreatePaymentLink={disableCanCreatePaymentLink}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          rowGap: "6px",
          position: "relative",
        }}
      >
        <Typography
          sx={{
            color: "#1C1C1C",
            fontFamily: "Montserrat",
            fontSize: "20px",
            fontWeight: 700,
            lineHeight: "30px",
            marginBottom: "6px",
          }}
        >
          {t("pages.payment.overview.gettingStartedTitle")}
        </Typography>
        <Typography
          sx={{
            color: "#111",
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontWeight: 400,
            lineHeight: "20px",
            marginBottom: "12px",
          }}
        >
          {t("pages.payment.overview.gettingStartedSubtitle")}
        </Typography>
        {disableCanCreatePaymentLink ? (
          <Typography
            sx={{
              color: "#FF0000",
              fontFamily: "Montserrat",
              fontSize: "12px",
              fontWeight: 400,
              lineHeight: "20px",
              marginBottom: "12px",
              position: "absolute",
              top: "0",
              right: "0",
            }}
          >
            {t("pages.payment.header.pleaseAddPaymentAccount")}
          </Typography>
        ) : (
          ""
        )}
      </Box>
      {isUserPaymentAccountLoading ? (
        <></>
      ) : userPaymentAccount ? (
        <DashboardView user={userPaymentAccount} handleAddReceivingDetails={handleAddReceivingDetails} />
      ) : (
        <NoPaymentAccountsView
          openLearnMorePopUp={openLearnMorePopUp}
          handleSetupPaymentAccount={openSelectCountryPopUp}
          handleAddReceivingDetails={handleAddReceivingDetails}
        />
      )}

      <ReceivingDetailsPopUp
        onClose={closeReceivingDetailsPopUp}
        open={isReceivingDetailsPopUpOpen}
        user={userPaymentAccount}
      />
      <LearnMorePopUp onClose={closeLearnMorePopUp} open={isLearnMorePopUpOpen} />
      <SelectCountryPopUp
        onClose={closeSelectCountryPopUp}
        open={isSelectCountryPopUpOpen}
        handleContinueSelection={handleSetupPaymentAccount}
      />
    </Box>
  );
};

export default PaymentOverview;
